import { useQuery } from '@tanstack/react-query'

import { fetchSkills } from 'api/fetchers/marketing-capabilities/skills/fetchSkills'
import { fetchSkillsByName } from 'api/fetchers/marketing-capabilities/skills/fetchSkillsByName'
import { useExploreLearnings } from 'store/ExploreLearnings'

export const useSkills = (isFilter = false) => {
  const exploreLearningsSearch = useExploreLearnings(state => state.search)
  const search = !isFilter ? exploreLearningsSearch : ''
  const params = {
    ...(search !== '' && !isFilter && { searchTerm: search }),
  }
  const queryFn =
    search === ''
      ? ({ signal }: any) => fetchSkills(params)(signal)
      : ({ signal }: any) => fetchSkillsByName(params)(signal)
  return useQuery({
    queryKey: ['skills', params],
    queryFn: queryFn,
    select: (data: any) => data.data,
    enabled: true,
  })
}
